module.exports = __webpack_public_path__ + "static/educated-d1d6e9901e969f7349aae47a379c22b0.jpg";